import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import VerbParagraph from '../../components/VerbParagraph';
import FiveStarLikert from '../../../client/components/FiveStarLikert';

class EndSessionLikertSubSlide extends Component {
    static propTypes = {
        responseData: PropTypes.object,
        handleClick: PropTypes.func
    };

    render() {
        const { responseData, handleClick } = this.props;

        return (
            <div className={'end-session-likert-slide'}>
                <div key={'likert-section-contentEval'}>
                    <VerbParagraph
                        messageId={'END_SESSION_CONTENT_VALUE'}
                        defaultMessage={'How did you like the content in this section?'}
                    />
                    <FiveStarLikert
                        idKey={'contentEval'}
                        score={get(responseData, 'contentEval.value', 0)}
                        handleClick={handleClick}
                    />
                </div>
            </div>
        );
    }
}

export default EndSessionLikertSubSlide;
